import { getServerEnv } from '../env-helper';
import flags from './flags.json';

export const isEnabledFeature = (env: ReturnType<typeof getServerEnv>, flag: keyof typeof flags) => {
  return flags[flag]?.includes(env);
};

const serverEnv = getServerEnv();

// Deprecated features -> flag
export const isTimeTriggerOrderFeatureEnabled = isEnabledFeature(serverEnv, 'TimeTriggerOrder');
export const isTradingFeeFeatureEnabled = isEnabledFeature(serverEnv, 'TradingFee');
